import { IComponentOptions } from 'angular';
import { PriorityGroupCtrl } from './priority-group.controller';

export const PriorityGroupStepComponent: IComponentOptions = {
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  controller: PriorityGroupCtrl,
  template: require('./priority-group.html'),
};
